import React, { Suspense, useEffect, useState } from "react";
import { Routes as SwitchRoute, Route, Navigate, useLocation } from "react-router-dom";

// Routes and layouts
import { authProtectedRoutes, publicRoutes } from "./routes";
import NonAuthLayout from "../layouts/NonAuth";
import AuthLayout from "../layouts/AuthLayout/";

// Helpers
import { checkToken } from "../helpers/api";
import Balls from "../pages/Templates/Loading";
import { useProfile } from "../contexts/ProfileContext";

const AuthProtected = (props) => {
    // Check both localStorage (remember me) and sessionStorage (session only)
    const token = localStorage.getItem("authUser") || sessionStorage.getItem("authUser");
    const authUser = token ? token.replace(/^"|"$/g, "") : "";

    if (props?.isAuthProtected && !props?.isPublicPage && !authUser) {
        return <Navigate to={{ pathname: "/login" }} />;
    } else {
        return <>{props?.children}</>;
    }
};

const Routes = () => {
    const [isPublicPage, setIsPublicPage] = useState(null);
    const [showMobileModal, setShowMobileModal] = useState(false);
    const [platform, setPlatform] = useState(null);

    const location = useLocation();
    const { fetchProfile } = useProfile();

    useEffect(() => {
        ValidateTokenFunction();
        detectMobilePlatform();
    }, []);

    const ValidateTokenFunction = async () => {
        // Check both localStorage (remember me) and sessionStorage (session only)
        const authUserToken = localStorage.getItem("authUser") || sessionStorage.getItem("authUser");
        const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";
        const response = await checkToken(authUser);
        if (!response?.tokenData) {
            setIsPublicPage(false);
        } else {
            fetchProfile();
            setIsPublicPage(false);
        }
    };

    const detectMobilePlatform = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isMobile = /android|iphone|ipad|ipod/i.test(ua);

        if (isMobile && !sessionStorage.getItem("mobileModalShown")) {
            if (/android/i.test(ua)) {
                setPlatform("android");
            } else if (/iphone|ipad|ipod/i.test(ua)) {
                setPlatform("ios");
            }
            setShowMobileModal(true);
            sessionStorage.setItem("mobileModalShown", "true");
        }
    };

    const closeMobileModal = () => {
        setShowMobileModal(false);
    };

    if (isPublicPage === null) {
        return (
            <div className="tw-flex tw-w-screen tw-h-screen tw-justify-center tw-items-center">
                <Balls />
            </div>
        );
    }

    return (
        <React.Fragment>
            <Suspense
                fallback={
                    <div className="tw-flex tw-w-screen tw-h-screen tw-justify-center tw-items-center">
                        <Balls />
                    </div>
                }
            >
                <SwitchRoute>
                    {publicRoutes.map((route, idx) => (
                        <Route path={route.path} element={<NonAuthLayout>{route.component}</NonAuthLayout>} key={idx} />
                    ))}

                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected isAuthProtected={true} isPublicPage={isPublicPage}>
                                    <AuthLayout>{route.component}</AuthLayout>
                                </AuthProtected>
                            }
                            key={idx}
                        />
                    ))}
                </SwitchRoute>
            </Suspense>

            {/* Mobile Device App Modal */}
            {showMobileModal && (
                <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-z-50 tw-flex tw-items-center tw-justify-center">
                    <div className="tw-bg-white tw-rounded-lg tw-shadow-xl tw-p-6 tw-w-full tw-max-w-sm tw-text-center tw-relative">
                        <button
                            onClick={closeMobileModal}
                            className="tw-absolute tw-top-2 tw-right-4 tw-text-gray-500 hover:tw-text-red-600 tw-text-xl"
                        >
                            &times;
                        </button>
                        <h2 className="tw-text-lg tw-font-bold tw-mb-2">Open in App</h2>
                        <p className="tw-text-gray-600 tw-mb-6">For the best experience, open this page in our mobile app.</p>

                        <a
                            href="https://play.google.com/store/apps/details?id=com.airebrokers"
                            className="tw-bg-green-600 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-block tw-mb-3"
                        >
                            Download from Google Play
                        </a>

                        <a
                            href="https://apps.apple.com/us/app/aire-brokers/id6742057602"
                            className="tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-block tw-mb-3"
                        >
                            Download from App Store
                        </a>

                        <button onClick={closeMobileModal} className="tw-text-sm tw-text-gray-500 hover:tw-underline">
                            Continue in browser
                        </button>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default Routes;
